<template>
  <choose-instance-name
    :email="email"
    :lang="lang"
    :SubdomainAndEmailAvailability="SubdomainAndEmailAvailability"
    @checkSubdomainAndEmailAvailability="onCheckSubdomainAndEmailAvailability"
    @proceedRegistration="onProceedInstanceRegistration">
  </choose-instance-name>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Emitter from 'components/mixins/emitter';

import PageProps from 'components/mixins/page-props';
import ChooseInstanceName from 'components/ui/subscription/cmpt-choose-instance-name';

export default {
  name: 'page-create-instance-step-one',
  mixins: [
    Emitter,
    PageProps,
  ],
  props: {
    email: {
      type: String,
      required: false,
      default: null,
    },
    lang: {
      type: String,
      required: false,
      default: null,
    },
  },
  components: {
    ChooseInstanceName,
  },
  // data() {
  //   return {
  //     email: null,
  //   };
  // },
  computed: {
    ...mapGetters([
      'SubdomainAndEmailAvailability',
      'InstanceRegister',
    ]),
  },
  methods: {
    ...mapActions([
      'CheckSubdomainAndEmailAvailability',
      'ProceedInstanceRegistration',
    ]),
    onCheckSubdomainAndEmailAvailability(query) {
      this.CheckSubdomainAndEmailAvailability({ query }).then(() => {
        this.broadcast('CmptChooseInstanceName', 'checked');
      }).catch(() => {
        this.errorNotification();
      });
    },
    onProceedInstanceRegistration(payload) {
      this.ProceedInstanceRegistration({ payload }).then(() => {
        this.onSuccessEvent(null, { email: payload.email });
      }).catch(() => {
        this.errorNotification();
      });
    },
  },
  // created() {
  //   this.email = get(this.$route, 'query.email', null);
  // },
  beforeDestroy() {
    this.$store.dispatch('ClearInstanceRegister');
    this.$store.dispatch('ClearSubdomainAndEmailAvailability');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/public/create-instance/step-1/page-create-instance-step-one.vue